import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "states/recoil";

const PrivateRoute = () => {
  const user = useRecoilValue(userState);
  const sessionToken = localStorage.getItem("sessionToken");

  // Check both session token and recoil user auth status
  if (sessionToken === "granted" || user.isAuthenticated) {
    return <Outlet />;
  } else {
    return <Navigate to="/signin" />;
  }
};

export default PrivateRoute;
